import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'

const state = {
  message: {
    content: '',
    type: ''
  },
  analyze_target_list: []
}

const actions = {

  async getAnalyzeTargetList ({ state, commit }) {
    // 両方
    const response = await ApiManager.request('Analyze').analyzeGet(3)
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setAnalyzeTargetList', response.data.data)
    }
  }
}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setAnalyzeTargetList (state, data) {
    state.analyze_target_list = data
  },
  setMessage (state, data) {
    state.message = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
